import React from "react";
import Svg, { Path } from "react-native-svg";

const Cross = (props) => (
  <Svg
    width={props.width || "8"}
    height={props.height || "8"}
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      opacity="1"
      d="M4.68712 3.9999L7.60747 1.07946C7.79752 0.889501 7.79752 0.582358 7.60747 0.392396C7.41751 0.202433 7.11036 0.202433 6.9204 0.392396L3.99996 3.31284L1.07961 0.392396C0.889556 0.202433 0.582501 0.202433 0.392539 0.392396C0.202487 0.582358 0.202487 0.889501 0.392539 1.07946L3.31289 3.9999L0.392539 6.92035C0.202487 7.11031 0.202487 7.41745 0.392539 7.60741C0.487209 7.70217 0.611685 7.74977 0.736073 7.74977C0.860461 7.74977 0.984848 7.70217 1.07961 7.60741L3.99996 4.68697L6.9204 7.60741C7.01516 7.70217 7.13955 7.74977 7.26394 7.74977C7.38832 7.74977 7.51271 7.70217 7.60747 7.60741C7.79752 7.41745 7.79752 7.11031 7.60747 6.92035L4.68712 3.9999Z"
      fill={props.fill || "black"}
    />
  </Svg>
);

export default Cross;
